import Error from '../model/Error';
import axios from 'axios';

export default class IsbjChildRepository {

    static findContracts(federationId, section, kindergarten, status, contractStatus, year) {
        const preparedStatus = this.getPreparedStatus(status);

        let url = '/federations/' + federationId + '/isbj/contracts?year=' + year + '&status=' + preparedStatus.join(',') + '&contract-status=' + contractStatus.join(',');
        if (section !== null) {
            url += '&section=' + section.id;
        }
        if (kindergarten !== null) {
            url += '&kindergarten=' + kindergarten.id;
        }

        return new Promise((resolve, reject) => {
            axios
                .get(url)
                .then(response => resolve(response.data.data))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findRegularTimes(federationId, section, kindergarten, status, contractStatus, year) {
        const preparedStatus = this.getPreparedStatus(status);

        let url = '/federations/' + federationId + '/isbj/regular-times?year=' + year + '&status=' + preparedStatus.join(',') + '&contract-status=' + contractStatus.join(',');
        if (section !== null) {
            url += '&section=' + section.id;
        }
        if (kindergarten !== null) {
            url += '&kindergarten=' + kindergarten.id;
        }

        return new Promise((resolve, reject) => {
            axios
                .get(url)
                .then(response => resolve(response.data.data))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static update(childId) {
        return new Promise((resolve, reject) => {
            axios
                .patch('/children/' + childId + '/isbj')
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static bulkUpdate(federationId, childIds) {
        return new Promise((resolve, reject) => {
            axios
                .patch(`/federations/${federationId}/isbj`, { children: childIds })
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static registerContract(subventionId, type) {
        const url = type === 'subvention' ? '/subventions/' + subventionId + '/isbj-contracts' : '/child-care-type-plus-subventions/' + subventionId + '/isbj-contracts';
        return new Promise((resolve, reject) => {
            axios
                .post(url)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static cancelContract(contractNumber) {
        return new Promise((resolve, reject) => {
            axios
                .delete('/isbj-contracts/' + contractNumber)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static updatePeriod(contractNumber) {
        return new Promise((resolve, reject) => {
            axios
                .put('/isbj-contracts/' + contractNumber + '/period')
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static changeScope(contractNumber) {
        return new Promise((resolve, reject) => {
            axios
                .put('/isbj-contracts/' + contractNumber + '/change-scope')
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static getVoucherDetail(federationId, voucherNumber) {
        return new Promise((resolve, reject) => {
            axios
                .get('/federations/' + federationId + '/isbj/vouchers/' + encodeURIComponent(voucherNumber))
                .then(response => resolve(response.data.data))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static getPreparedStatus(status) {
        let preparedStatus = status.slice();
        if (preparedStatus.indexOf('not_in_sync') !== -1) {
            preparedStatus.push('no_isbj_contract');
            preparedStatus.push('out_of_sync');
        }

        return preparedStatus;
    }
}
